import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-save.png'

const SaveBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default SaveBtn
